import i18n from '@/i18n'

import landing from '@/components/layouts/Landing'

import cnHome from './cn/home'
import cnRuyi from './cn/ruyi'
import cnTechnology from './cn/technology'
import cnFashion from './cn/fashion'
import cnSustainability from './cn/sustainability'
import cnContent from './cn/content'

import enHome from './en/home'
import enRuyi from './en/ruyi'
import enTechnology from './en/technology'
import enFashion from './en/fashion'
import enSustainability from './en/sustainability'
import enContent from './en/content'

export default [
  {
    path: '/',
    component: landing,
    redirect () {
      return {
        name: `${i18n.locale}.home`
      }
    },
    children: [
      // en
      enHome,
      enRuyi,
      enTechnology,
      enFashion,
      enSustainability,
      enContent,
      // default
      cnHome,
      cnRuyi,
      cnTechnology,
      cnFashion,
      cnSustainability,
      cnContent
    ]
  },
  {
    path: '*',
    redirect () {
      return {
        name: `${i18n.locale}.home`
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js